import { forwardRef } from 'react'
import { NavLink as RouterLink } from 'react-router-dom'

import { useTheme, useMediaQuery } from '@mui/material'
import Button from '@mui/material/Button'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

interface RouteButtonProps {
  name: string;
  params?: string[]
  disabled: boolean;
  path: string;
  onClick?(): void
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const NavLinkMui = forwardRef<any, any>((props, ref) => {
  const theme = useTheme()
  const isTablet = useMediaQuery('(max-width:900px)', {
    noSsr: true,
  })
  const { ...otherProps } = props

  const lightColor = (!isTablet) ? 'white' : theme.palette.primary.main
  return (
    <RouterLink
      {...otherProps}
      ref={ref}
      role={undefined}
      style={({ isActive }) => ((isActive) ? {
        color: (theme.palette.mode === 'light') ? lightColor : 'white',
        textDecoration: 'none',
      } : null)}
    />
  )
})

export const RouteButton = ({
  name, params, disabled, path, onClick,
}: RouteButtonProps): JSX.Element | null => {
  if (disabled) return null

  const dprops = { sx: { my: 2, display: 'flex', fontWeight: 500 } }

  const pathWithParams = (params) ? `${path}/${params.join('/')}` : path

  if (path.startsWith('http')) {
    const bprops = { sx: { ...dprops.sx, alignItems: 'flex-start', '& span': { margin: 0 } } }
    return (
      <Button
        color="secondary"
        key={name}
        target="_blank"
        rel="noopener noreferrer"
        href={pathWithParams}
        endIcon={<OpenInNewIcon sx={{ width: 8, height: 8 }} />}
        {...bprops}
      >
        {name}
      </Button>
    )
  }
  const bprops = (disabled) ? {
    ...dprops,
    disableRipple: true,
    disableFocusRipple: true,
    disableElevation: true,
  } : {
    ...dprops,
    component: NavLinkMui,
    to: pathWithParams,
  }

  return (
    <Button
      color="secondary"
      key={name}
      onClick={onClick}
      {...bprops}
    >
      {name}
    </Button>
  )
}
